import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useHealthGoalBodyForStepsExerciseStyles = makeStyles({
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalL),
  },
  calendar: {
    display: 'flex',
    gap: tokens.spacingHorizontalSNudge,
    fontWeight: tokens.fontWeightBold,
    fontSize: tokens.fontSizeBase200,
  },
  calculatedUnit: {
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
  },
  measurementCount: {
    fontSize: tokens.fontSizeBase500,
    lineHeight: tokens.lineHeightBase500,
    fontWeight: tokens.fontWeightSemibold,
    paddingRight: tokens.spacingHorizontalSNudge,
  },
  progressBar: {
    paddingTop: tokens.spacingVerticalS,
  },
  leftRightWrapper: {
    display: 'flex',
  },
  leftSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  rightSection: {
    marginLeft: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  goalRepeatabilityRate: {
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
    textAlign: 'right',
  },
});
